// api.js

import axiosInstance from "../axiosInstance";

export const trackingService = {
  publish: async (data) => {
    try {
      let response = await axiosInstance.post("/manual-tracking", data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
